/*
  Fill Co: pay-later line helpers (snippets/fc-afterpay.liquid).
  PayPal: the PayPal badge and (i) open PayPal's own Pay in 4 dialog. PayPal's script is loaded by the
  PayPal Pay Later Messaging app embed under the namespace PayPalSDK; if it never arrives, the
  PayPal part is hidden (html.fc-no-paypal) and Afterpay shows on its own.
  Zip: this file loads zip-widget.min.js (id zm-widget, so the Zip app's own loader skips it); Zip's script
  draws and opens its own line and dialog. If window.Zip never arrives, the Zip line is hidden
  (html.fc-no-zip). Enter / Space on the Zip line opens Zip's dialog.
  Cart drawer: the drawer is a modal <dialog> (top layer), so anything the Afterpay, PayPal or Zip scripts
  add to <body> would open behind it and could not be clicked. When one of them is opened from inside an
  open modal dialog, its dialog is placed inside that dialog instead (Afterpay's <afterpay-modal> is moved
  there, PayPal's dialog is drawn there, Zip's overlay is moved there), and moved back to <body> when
  opened from the page. Zip removes its overlay with document.body.removeChild, so that call is allowed
  to remove a Zip overlay that now sits inside the drawer.
*/
(function () {
  if (window.fcPayLater) return;
  window.fcPayLater = true;

  var root = document.documentElement;
  var ZIP_OVERLAY = '.zip-widget__popup__overlay-external-modal';
  var waited = 0;

  function paypal() {
    var sdk = window.PayPalSDK;
    return sdk && typeof sdk.MessagesModal === 'function' ? sdk : null;
  }

  (function check() {
    if (paypal()) {
      root.classList.remove('fc-no-paypal');
      return;
    }
    if (waited >= 10000) {
      root.classList.add('fc-no-paypal');
      return;
    }
    waited += 500;
    setTimeout(check, 500);
  })();

  if (!document.getElementById('zm-widget')) {
    var zipScript = document.createElement('script');
    zipScript.id = 'zm-widget';
    zipScript.src = 'https://static.zip.co/lib/js/zm-widget-js/dist/zip-widget.min.js';
    zipScript.async = true;
    document.head.appendChild(zipScript);
  }

  var zipWaited = 0;
  (function checkZip() {
    if (window.Zip && window.Zip.Widget) {
      root.classList.remove('fc-no-zip');
      return;
    }
    if (zipWaited >= 10000) {
      root.classList.add('fc-no-zip');
      return;
    }
    zipWaited += 500;
    setTimeout(checkZip, 500);
  })();

  /* Where a pay-later dialog should open: inside the open modal dialog the trigger sits in, else <body> */
  function hostFor(node) {
    var dialog = node && node.closest ? node.closest('dialog') : null;
    if (dialog && dialog.open) {
      try {
        if (dialog.matches(':modal')) return dialog;
      } catch (error) {
        return dialog;
      }
    }
    return document.body;
  }

  /* Clicks inside a pay-later dialog that sits in the drawer stop at it, so the drawer does not read them
     as a click on its backdrop and close */
  function stopAtDialog(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (path[i].tagName === 'DIALOG') {
        event.stopPropagation();
        return;
      }
    }
  }

  function moveTo(host, node) {
    if (!node || !host) return;
    if (host !== document.body && !node.fcStopAtDialog) {
      node.fcStopAtDialog = true;
      node.addEventListener('click', stopAtDialog);
    }
    if (node.parentNode !== host) host.appendChild(node);
  }

  /* Overlays added to <body> by Afterpay or Zip right after a click inside the drawer are moved into it */
  var pendingHost = null;
  var pendingUntil = 0;

  new MutationObserver(function (records) {
    if (!pendingHost || pendingHost === document.body || Date.now() > pendingUntil || !pendingHost.open) return;
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'AFTERPAY-MODAL' || node.matches(ZIP_OVERLAY)) moveTo(pendingHost, node);
      });
    });
  }).observe(document.body, { childList: true });

  var bodyRemoveChild = document.body.removeChild;
  document.body.removeChild = function (child) {
    if (child && child.parentNode && child.parentNode !== this && child.matches && child.matches(ZIP_OVERLAY)) {
      return child.parentNode.removeChild(child);
    }
    return bodyRemoveChild.call(this, child);
  };

  /* Capture phase: runs before the Afterpay and Zip scripts handle the same click */
  document.addEventListener(
    'click',
    function (event) {
      var path = event.composedPath ? event.composedPath() : [event.target];
      var trigger = null;
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'SQUARE-PLACEMENT' || (node.classList && node.classList.contains('fc-zip'))) {
          trigger = node;
          break;
        }
      }
      if (!trigger) return;
      var host = hostFor(trigger);
      pendingHost = host;
      pendingUntil = Date.now() + 4000;
      if (trigger.tagName === 'SQUARE-PLACEMENT') moveTo(host, document.querySelector('afterpay-modal'));
    },
    true
  );

  /* Capture phase: the drawer stops keydown from bubbling to the document */
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var zip = event.target instanceof Element ? event.target.closest('.fc-zip') : null;
      if (!zip) return;
      event.preventDefault();
      var inner = zip.querySelector('.zip-container') || zip;
      inner.click();
    },
    true
  );

  /* PayPal: one dialog per place it opens from (the page, or the drawer), drawn inside that place */
  var paypalModals = [];

  function paypalModalFor(host, sdk, props) {
    for (var i = 0; i < paypalModals.length; i++) {
      if (paypalModals[i].host === host && paypalModals[i].box.isConnected) return paypalModals[i];
    }
    var box = document.createElement('div');
    box.className = 'fc-paylater-modal';
    moveTo(host, box);
    var modal = sdk.MessagesModal(props);
    var entry = { host: host, box: box, modal: modal, ready: Promise.resolve(modal.render(box)) };
    paypalModals.push(entry);
    return entry;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target instanceof Element ? event.target.closest('[data-fc-paypal-amount]') : null;
    if (!trigger) return;
    event.preventDefault();

    var sdk = paypal();
    if (!sdk) return;

    var props = {
      amount: parseFloat(trigger.getAttribute('data-fc-paypal-amount')) || undefined,
      placement: trigger.getAttribute('data-fc-paypal-placement') || 'product',
    };

    try {
      var entry = paypalModalFor(hostFor(trigger), sdk, props);
      entry.ready
        .then(function () {
          return entry.modal.updateProps(props);
        })
        .then(function () {
          entry.modal.show();
        })
        .catch(function (error) {
          console.warn('[Fill Co] PayPal Pay in 4 dialog failed', error);
        });
    } catch (error) {
      console.warn('[Fill Co] PayPal Pay in 4 dialog failed', error);
    }
  });
})();
